<template>
  <div class="login">
    <span class="login_title"
          @click="viewVersion()">鸣 物 联-管 理</span>
    <div class="loginForm_bg">
      <div class="loginForm_title">账&nbsp;&nbsp;号&nbsp;&nbsp;登&nbsp;&nbsp;录</div>
      <el-form ref="loginForm"
               :model="loginForm"
               :rules="loginRules"
               v-loading="dataListLoading"
               class="loginForm"
               label-position="left"
               label-width="80px"
               status-icon>
        <el-form-item prop="username">
          <span slot="label">
            <img alt=""
                 class="input_icon"
                 src="../assets/img/Login-Account-icon.png"/>
          </span>
          <div class="splitLine"></div>
          <el-input v-model="loginForm.username"
                    autocomplete="off"
                    placeholder="请输入账号"
                    @keyup.enter.native="userLogin()"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <span slot="label">
            <img alt=""
                 class="input_icon"
                 src="../assets/img/Login-password-icon.png"/>
          </span>
          <div class="splitLine"></div>
          <el-input v-model="loginForm.password"
                    :type="passwordType"
                    autocomplete="off"
                    placeholder="请输入密码"
                    @keyup.enter.native="userLogin()"></el-input>
          <img :src="passwordType == 'password' ? unshow_password_icon : show_password_icon"
               alt=""
               class="showPassword_icon"
               @click="showPassword()"/>
        </el-form-item>
      </el-form>
      <el-button class="login_btn"
                 type="primary"
                 @click="userLogin()">登&nbsp;&nbsp;&nbsp;录
      </el-button>
      <div class="function">
        <span class="function_text"
              v-show="false"
              @click="openRegisterDialog()">注册</span>
        <span class="function_text"
              v-show="false"
              @click="openForgetPasswordDialog()">忘记密码？</span>
      </div>
    </div>

    <!-- 注册 -->
    <el-dialog :before-close="registerCancel"
               :visible.sync="registerDialog"
               title="注册"
               width="30%">
      <el-form ref="registerForm"
               :model="registerForm"
               :rules="registerRule"
               class="registerForm"
               label-width="35%">
        <el-form-item label="账号"
                      prop="username">
          <el-input v-model="registerForm.username"
                    placeholder="请输入手机号码"
                    style="width: 200px;"
                    @keyup.enter.native="register()"></el-input>
        </el-form-item>
        <el-form-item label="验证码"
                      prop="verificationCode">
          <el-input v-model="registerForm.verificationCode"
                    placeholder="验证码"
                    style="width: 85px;"
                    @keyup.enter.native="register()"></el-input>
          <el-button :disabled="waitRegisterTime != 0"
                     size="small"
                     type="primary"
                     @click="getVerifyCode(3)">
            {{ waitRegisterTime == 0 ? '获取验证码' : `( ${waitRegisterTime} ) 获取验证码` }}
          </el-button>
        </el-form-item>
        <el-form-item label="密码"
                      prop="password">
          <el-input v-model="registerForm.password"
                    placeholder="请输入密码"
                    style="width: 200px;"
                    type="password"
                    @keyup.enter.native="register()"></el-input>
        </el-form-item>
        <el-form-item label="确认密码"
                      prop="rePassword">
          <el-input v-model="registerForm.rePassword"
                    placeholder="请再次输入密码"
                    style="width: 200px;"
                    type="password"
                    @keyup.enter.native="register()"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="checked"
                       class="checkbox"></el-checkbox>
          <span>已阅读并同意</span><span class="clause">《相关条款》</span>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer"
            style="display: flex;justify-content: space-between">
        <el-button @click="registerCancel()">取 消</el-button>
        <el-button type="primary"
                   @click="register()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 忘记密码 -->
    <el-dialog :before-close="forgetPasswordCancel"
               :visible.sync="forgetPasswordDialog"
               title="修改密码"
               width="30%">
      <el-form ref="forgetPasswordForm"
               :model="forgetPasswordForm"
               :rules="forgetPasswordRule"
               class="forgetPasswordForm"
               label-width="35%">
        <el-form-item label="账号"
                      prop="username">
          <el-input v-model="forgetPasswordForm.username"
                    placeholder="请输入手机号码"
                    style="width: 200px;"
                    @keyup.enter.native="forgetPassword()"></el-input>
        </el-form-item>
        <el-form-item label="验证码"
                      prop="verificationCode">
          <el-input v-model="forgetPasswordForm.verificationCode"
                    placeholder="验证码"
                    style="width: 85px;"
                    @keyup.enter.native="forgetPassword()"></el-input>
          <el-button :disabled="waitForgetPasswordTime != 0"
                     size="small"
                     type="primary"
                     @click="getVerifyCode(4)">
            {{ waitForgetPasswordTime == 0 ? '获取验证码' : `( ${waitForgetPasswordTime} ) 获取验证码` }}
          </el-button>
        </el-form-item>
        <el-form-item label="密码"
                      prop="password">
          <el-input v-model="forgetPasswordForm.password"
                    placeholder="请输入密码"
                    style="width: 200px;"
                    type="password"
                    @keyup.enter.native="forgetPassword()"></el-input>
        </el-form-item>
        <el-form-item label="确认密码"
                      prop="rePassword">
          <el-input v-model="forgetPasswordForm.rePassword"
                    placeholder="请再次输入密码"
                    style="width: 200px;"
                    type="password"
                    @keyup.enter.native="forgetPassword()"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer"
            style="display: flex;justify-content: space-between">
        <el-button @click="forgetPasswordCancel()">取 消</el-button>
        <el-button type="primary"
                   @click="forgetPassword()">确 定</el-button>
      </span>
    </el-dialog>


    <!-- 选择角色 开始 -->
    <el-dialog :before-close="selectRoleCancel"
               :visible.sync="selectRoleDialog"
               title="选择角色"
               width="30%">

      <div v-for="item in roleAndMenuList">

        <el-button
          @click="getUserInfo(item)" style="margin-right: 10px;">{{ item.roleName }}

        </el-button>

      </div>

    </el-dialog>
    <!-- 选择角色 结束 -->

  </div>
</template>

<script>
import '../assets/css/login.css'
import '../assets/font/font.css'

export default {
  data() {
    var validateUsername = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入用户名'))
      } else {
        callback()
      }
    }
    var validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    const registerPass = (rule, value, callback) => {
      if (this.registerForm.password) {
        if (value !== this.registerForm.password) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请输入密码'))
      }
    }
    const forgetPasswordPass = (rule, value, callback) => {
      if (this.forgetPasswordForm.password) {
        if (value !== this.forgetPasswordForm.password) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请输入密码'))
      }
    }
    return {
      show_password_icon: require('../assets/img/show_password_icon.png'),
      unshow_password_icon: require('../assets/img/unshow_password_icon.png'),
      loginForm: {
        username: '',
        password: '',
      },
      passwordType: 'password',
      loginRules: {
        username: [{validator: validateUsername, trigger: 'blur'}],
        password: [{validator: validatePassword, trigger: 'blur'}],
      },
      registerDialog: false,
      registerForm: {
        username: '',
        verificationCode: '',
        verificationCodeId: '',
        password: '',
        rePassword: '',
      },
      registerRule: {
        username: [
          {required: true, message: '账号不能为空', trigger: 'blur'},
        ],
        verificationCode: [
          {required: true, message: '验证码不能为空', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '密码不能为空', trigger: 'blur'},
        ],
        rePassword: [
          {required: true, validator: registerPass, trigger: 'blur'},
        ],
      },
      waitRegisterTime: 0,
      checked: false,
      forgetPasswordDialog: false,
      forgetPasswordForm: {
        username: '',
        verificationCode: '',
        verificationCodeId: '',
        password: '',
        rePassword: '',
      },
      forgetPasswordRule: {
        username: [
          {required: true, message: '账号不能为空', trigger: 'blur'},
        ],
        verificationCode: [
          {required: true, message: '验证码不能为空', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '密码不能为空', trigger: 'blur'},
        ],
        rePassword: [
          {required: true, validator: forgetPasswordPass, trigger: 'blur'},
        ],
      },
      waitForgetPasswordTime: 0,
      selectRoleDialog: false,
      roleAndMenuList: [],
      userId: 0,
      dataListLoading: false,
    }
  },

  computed: {},

  created() {
    let self = this
  },

  mounted() {
  },

  methods: {
    selectRoleCancel() {
      let self = this

      self.selectRoleDialog = false
    },

    getUserInfoBySelectRole() {

    },

    // 密码明文
    showPassword() {
      let self = this

      self.passwordType == ''
        ? (self.passwordType = 'password')
        : (self.passwordType = '')
    },

    // 注册
    openRegisterDialog() {
      let self = this

      self.registerDialog = true
    },

    registerCancel() {
      let self = this
      Object.keys(self.registerForm).forEach(
        (key) => (self.registerForm[key] = '')
      )
      self.$refs.registerForm.resetFields()
      self.waitRegisterTime = 0
      self.registerDialog = false
    },

    register() {
      let self = this

      let username = self.registerForm.username
      let password = self.registerForm.password
      let verifyCode = self.registerForm.verificationCode
      let verifyCodeId = self.registerForm.verificationCodeId

      let formdata = new FormData()

      formdata.append('userName', username)
      formdata.append('passWord', password)
      formdata.append('verifyCode', verifyCode)
      formdata.append('verifyCodeId', verifyCodeId)

      self.$axios
        ._getRegister(formdata)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.registerCancel()

            self.$message.success('注册成功')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })
    },

    // 忘记密码
    openForgetPasswordDialog() {
      let self = this

      self.forgetPasswordDialog = true
    },

    forgetPasswordCancel() {
      let self = this
      Object.keys(self.forgetPasswordForm).forEach(
        (key) => (self.forgetPasswordForm[key] = '')
      )
      self.$refs.forgetPasswordForm.resetFields()

      self.waitForgetPasswordTime = 0
      self.forgetPasswordDialog = false
    },

    forgetPassword() {
      let self = this

      let username = self.forgetPasswordForm.username
      let password = self.forgetPasswordForm.password
      let verifyCode = self.forgetPasswordForm.verificationCode
      let verifyCodeId = self.forgetPasswordForm.verificationCodeId

      let formdata = new FormData()

      formdata.append('phone', username)
      formdata.append('passWord', password)
      formdata.append('verifyCode', verifyCode)
      formdata.append('verifyCodeId', verifyCodeId)

      self.$axios
        ._forgetPassword(formdata)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.forgetPasswordCancel()

            self.$message.success('修改成功')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })
    },

    // 获取验证码
    getVerifyCode(VerifyCodeType) {
      // VerifyCodeType: 3 - 注册 , VerifyCodeType: 4 - 忘记密码
      let self = this

      let phone = ''
      let type = VerifyCodeType

      if (VerifyCodeType == 3) {
        phone = self.registerForm.username
      } else {
        phone = self.forgetPasswordForm.username
      }

      let str = {
        phone: phone,
        type: type,
      }

      self.$axios
        ._getVerifyCode(str)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            if (VerifyCodeType == 3) {
              self.waitRegisterTime = 60
              self.countDown(VerifyCodeType)
              self.registerForm.verificationCodeId = datas.data.verifyCodeId
            } else if (VerifyCodeType == 4) {
              self.waitForgetPasswordTime = 60
              self.countDown(VerifyCodeType)
              self.forgetPasswordForm.verificationCodeId =
                datas.data.verifyCodeId

              console.log(
                self.forgetPasswordForm.verificationCodeId,
                datas,
                123123123
              )
            }
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })
    },

    // 获取验证码倒计时
    countDown: function (VerifyCodeType) {
      let self = this

      if (VerifyCodeType == 3) {
        if (self.waitRegisterTime != 0) {
          self.waitRegisterTime--
          setTimeout(function () {
            self.countDown(VerifyCodeType)
          }, 1000)
        }
      } else if (VerifyCodeType == 4) {
        if (self.waitForgetPasswordTime != 0) {
          self.waitForgetPasswordTime--
          setTimeout(function () {
            self.countDown(VerifyCodeType)
          }, 1000)
        }
      }
    },

    // 登录
    userLogin: function () {
      let self = this

      // 校验表单
      let validateForm = null

      self.$refs['loginForm'].validate((valid) => {
        if (valid) {
          validateForm = true
        } else {
          validateForm = false
        }
      })

      if (!validateForm) {
        return
      }

      sessionStorage.setItem('token', '') // 登录需token

      let username = self.loginForm.username
      let password = self.loginForm.password

      let param = {
        userPhone: username,
        userPassword: password
      }

      self.dataListLoading = true

      self.$axios
        ._login(param)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {

            self.dataListLoading = false

            self.roleAndMenuList = datas.data.roleAndMenu
            sessionStorage.setItem('token', datas.data.jwtIot)


            /*

                self.roleAndMenuList.forEach((elem, index) => {
                  if (elem.roleId !== 1 && elem.roleId !== 2) {
                    self.roleAndMenuList.splice(index, 1);
                  }
                })

                if (self.roleAndMenuList.length === 0) {
                  self.$message.warning("房东和管理员才能登录系统")
                } else {
                  sessionStorage.setItem('token', datas.data.jwtIot)

                  self.userId = datas.data.userId

                  if (self.roleAndMenuList.length === 1) {
                    self.getUserInfo(self.roleAndMenuList[0])
                  } else {
                    self.selectRoleDialog = true
                  }
                }*/


            // self.getUserInfo(datas.data.authority.id)
            //
            // self.$router.push({
            //   path: '/homepage',
            //   query: {},
            // })

            self.getUserInfo(datas.data.userId, 12)


            self.$message.success('登录成功')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })
    },

    // 获取用户信息
    getUserInfo(userId, roleType) {
      let self = this

      let str = {
        userId: userId,
        appParamUserInfoType: roleType
      }

      self.$axios
        ._getUserInfo(str)
        .then((res) => {

          const datas = res.data

          if (datas.code == 0) {
            sessionStorage.setItem('userInfo', JSON.stringify(datas.data))

            self.$router.push({
              path: '/homepage',
              query: {},
            })
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })
    },

    // 查看版本号
    viewVersion: function () {
      console.log('版本号 =========> v1.0.0 --- dev')
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/login.vue